export const ONE_SECOND_MILLISECONDS = 1000;

export const ONE_MINUTE_MILLISECONDS = 60 * ONE_SECOND_MILLISECONDS;
